module.exports = __webpack_public_path__ + "img/DualRing-1.1s-28px.64e0c7fe.svg";